import React from 'react';
import Script from 'next/script';
import useLocale from '@/hooks/useLocale';

export const YotpoReferrals = ({
  cb,
}: {
  cb?: (rendered: boolean) => void;
}) => {
  const locale = useLocale();

  const euId = 'rTI_YLPWl0Up63wf-8Lzfg';
  const idMap = {
    'en-US': 'OX2ns6c4uaYfDkIoVNQm4Q',
    'en-GB': 'hewSh00xGf7a2ztitMRwNg',
    'en-EU': euId,
    de: euId,
    nl: euId,
    fr: euId,
    es: euId,
  };

  const idToUse = idMap[locale as keyof typeof idMap];
  if (!idToUse) return null;
  cb?.(true);

  return (
    <Script
      src={`https://cdn-widgetsrepository.yotpo.com/v1/loader/${idToUse}`}
    />
  );
};
